import { Suspense, lazy } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ReadySignal from "@/components/ReadySignal";
import ChunkErrorBoundary from "@/components/ChunkErrorBoundary";

// Below-the-fold sections are code-split so the initial bundle stays small.
// Each becomes its own chunk that loads in parallel after the hero paints.
const StatsMarquee = lazy(() => import("@/components/landing/StatsMarquee"));
const HowItWorks = lazy(() => import("@/components/landing/HowItWorks"));
const CardTypes = lazy(() => import("@/components/landing/CardTypes"));
const ScannerApp = lazy(() => import("@/components/landing/ScannerApp"));
const PushNotifications = lazy(() => import("@/components/landing/PushNotifications"));
const ROICalculator = lazy(() => import("@/components/landing/ROICalculator"));
const Comparison = lazy(() => import("@/components/landing/Comparison"));
const VendorShowcase = lazy(() => import("@/components/landing/VendorShowcase"));
const Pricing = lazy(() => import("@/components/landing/Pricing"));
const GrowthPartner = lazy(() => import("@/components/landing/GrowthPartner"));
const Automations = lazy(() => import("@/components/landing/Automations"));
const FAQ = lazy(() => import("@/components/landing/FAQ"));
const JoinFooter = lazy(() => import("@/components/landing/JoinFooter"));

// content-visibility:auto lets the browser skip rendering offscreen sections
// until they scroll near the viewport — big mobile main-thread win.
const Cv = ({ children }) => <div className="cv-auto">{children}</div>;

export default function Landing({ onReady, onError }) {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[#07182D] text-white overflow-x-hidden"
    >
      <Header />
      <Hero />
      <ChunkErrorBoundary onError={onError}>
        <Suspense fallback={<div className="min-h-screen bg-[#07182D]" />}>
          <StatsMarquee />
          <Cv><HowItWorks /></Cv>
          <Cv><CardTypes /></Cv>
          <Cv><ScannerApp /></Cv>
          <Cv><PushNotifications /></Cv>
          <Cv><ROICalculator /></Cv>
          <Cv><Comparison /></Cv>
          <Cv><VendorShowcase /></Cv>
          <Cv><Pricing /></Cv>
          <Cv><GrowthPartner /></Cv>
          <Cv><Automations /></Cv>
          <Cv><FAQ /></Cv>
          <Cv><JoinFooter /></Cv>
          {/* Fires only once every lazy section above has resolved. */}
          <ReadySignal onReady={onReady} />
        </Suspense>
      </ChunkErrorBoundary>
    </main>
  );
}
